import moment from 'moment'
import momentTimezone from 'moment-timezone'

import * as dateConstants from './date_constants'

export function numToDayOfWeekShortCap(numericalDayOfWeek) {
  return dateConstants.dayShortCap[numericalDayOfWeek] 
}

export function numToDayOfWeekShort(numericalDayOfWeek) {
  return dateConstants.dayShort[numericalDayOfWeek] 
}

export function numToDayOfWeekLong(numericalDayOfWeek) {
  return dateConstants.dayLong[numericalDayOfWeek]
}

export function numToMonthLong(numericalMonth) {
  return dateConstants.monthLong[numericalMonth]
}

function dateToMonthShort(date) {
  return dateConstants.monthShort[date.month()]
}

export function dateEqual(date1, date2) {
  return date1.year() === date2.year() && date1.month() === date2.month() && date1.date() === date2.date()
}

export function dateTimeEqual(date1, date2) {
  return date1.valueOf() === date2.valueOf()
}

function getMeridiem(date) {
  if (Math.floor(date.hours() / 12) === 0) {
    return 'am'
  }
  return 'pm'
}

function customGetHours(date) {
  if (date.hours() % 12 === 0) {
    return 12
  }
  return date.hours() % 12
}

function customGetMinutes(date) {
  let minutes = date.minutes()
  if (minutes < 10) {
    minutes = '0' + minutes 
  }
  return minutes
}

export function getTimezoneShort(date) {
  const zoneName = momentTimezone.tz.guess(true) 
  return momentTimezone.tz(zoneName).zoneAbbr()
}

export function getTimezoneLong(date) {
  date = date ? new Date(date.toISOString()) : new Date()
  if (document.documentMode) {
    date = date.toString().split('(')
    return date[1].split(')')[0]
  } else {
    return date.toLocaleTimeString('en-us',{ timeZoneName:'long'} ).split(' ').slice(2).join(' ')
  }
}

export function timePrettyPrint(date) { 
  return `${customGetHours(date)}:${customGetMinutes(date)} ${getMeridiem(date)}`
}

export function completeDatePrettyPrint(date) {
  return `${numToMonthLong(date.month())} ${date.date()}, ${date.year()} at ${customGetHours(date)}:${customGetMinutes(date)} ${getMeridiem(date)}`
}

export function shortDatePrettyPrint(date) {
  return `${numToDayOfWeekShort(date.day())}, ${dateToMonthShort(date)} ${date.date()}`
}

export function shortDateTimePrettyPrint(date) {
  return `${numToDayOfWeekShort(date.day())}, ${dateToMonthShort(date)} ${date.date()}, ${timePrettyPrint(date)}`
}

export function snakeDatePrint(date) {
  return `${date.year()}-${date.month() + 1}-${date.date()}`
}

export function speechDateValue(date) {
  return `${numToDayOfWeekLong(date.day())} ${numToMonthLong(date.month())} ${date.date()}`
}

export function midnightFormat(date) {
    date.set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
    date.toISOString()
    return date.format()
}